export default __webpack_public_path__ + "static/media/tms-portabella-2000i.58a2cb99.webp";